import { InjectionToken } from '@angular/core';
import { IHestiaCoreConfig } from '@hestia/ngx-types';

export const CORE_HESTIA_CONFIG = new InjectionToken<IHestiaCoreConfig>(
  'CORE_HESTIA_CONFIG'
);

export const moduleI18nScope = 'hestiaCommon';
